var windowOrGlobal = typeof self === 'object' && self.self === self && self || typeof global === 'object' && global.global === global && global || window;

export { windowOrGlobal as default };
//# sourceMappingURL=window-or-global.js.map
